// helpers
import { cn } from "src/utils/common.helper"
// assets
import { MailIcon } from "@assets/icons/Mail-icon"

export const Footer = ({ className = "" }) => (
    <div
        className={cn(
            "flex items-center justify-between text-[var(--text-secondary)] flex-shrink-0 gap-2 lg:gap-3 w-full h-16 3xl-tall:h-24 px-5 lg:px-10 xl:px-14 2xl:px-20 border",
            className
        )}
    >
        <div className="flex items-center gap-1 flex-shrink-0">
            <MailIcon className="h-3.5 w-3.5" />
            <p className="text-xs">help@orbsway.com</p>
        </div>
        <p className="text-xs text-right whitespace-pre-line sm:whitespace-nowrap flex-shrink-0">
            {`Terms and Conditions and \n Privacy Policy`}
        </p>
    </div>
)
